import React,{useState, useEffect, useContext,useCallback,useRef} from 'react';
import Header from './headerweightreport'
import DatePicker from "react-datepicker";
import BranchContext from "../context/branch";
import {getReport,GetprivilegePage,GetRegisterface} from "../../services/wms";
import Renderdata from './renderweightsum'
import numberWithCommas from '../common/number';
import moment from "moment";
import ScrollToTop from "../common/ScrollToTop";
import { toast } from "react-toastify";
import Renderface from "../../components/wms/renderface";
import {ConfirmData} from "../../services/wms";
import Headerproduct from "./headerproduct501";
import ConfirmSubmitface from "./../common/confirmSubmitface";

const Manageface = (props) => {
    const { currentBranch } = useContext(BranchContext);
    const [branchid, setbranchid] = useState(0);
    const [reportlist, setreportlist] = useState([]);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [hasMore, setHasMore] = useState(false);
    const [total, settotal] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [reportId, setreportId] = useState('01');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [amount, setamount] = useState(0);
    const [totalweight, settotalweight] =  useState(0);
    const [showonscroll, setshowonscroll] = useState(false)
    const [pageSize, setPageSize] = useState(25);
    const [ckPermit, setckPermit] = useState(false);
    const [facelist, setfacelist] = useState([]);
    const [list, setlist] = useState([]);
    const [cardid, setcardid] = useState("");
    const [status, setstatus] = useState("0");
    const [askConfirm, setaskConfirm] = useState(false);
    const [message, setmessage] = useState("");
  useEffect(() => {
    setreportlist([]);
  }, [currentBranch,reportId,startDate,endDate,branchid ,pageSize]);
  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const { data: result } = await GetRegisterface(moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),moment(endDate, "YYYY-MM-DD").format("YYYY-MM-DD"),currentBranch._id,status);

      if (result) {
        setfacelist(result);
        settotal(result.length);
        setLoading(false)
      }
    };
    loadData();
  }, [currentBranch,startDate,endDate,status]);
      useEffect(() => {
        if (!currentBranch) return;
        if (currentBranch._id == "0" || currentBranch._id == "") return;
        const loadPrivilege = async () => {
          const { data: result } = await GetprivilegePage(
            "reportsumary",
            currentBranch._id
          );
          if (result.status === "success") {
            setckPermit(true);
          } else if (result.status === "error") {
            toast.error(result.message);

            if (result.message === "invalid token") {
              const urlGoBack = "logout";
              setTimeout(props.history.replace(urlGoBack), 1000);
            }
          }
        };
        loadPrivilege();
      }, [currentBranch, branchid]);

    const handleStartDate = (event) =>{
        setStartDate(event);
        setPageNumber(1)
      }
   const handleReportChange = (event) =>{
    setreportId(event)
   }
   const handleonClick = (event) =>{
    setcardid(event.IdentityID)
    setlist(event)
    setaskConfirm(true)
   }
   const handleProductChange = (event) => {
    // setPageNumber(1);
    setstatus(event);
  };
  const handleConfirmSubmit = (e) => {   
    // setcardid(e)
    doSubmit();
    setaskConfirm(false);
  };
   const doSubmit = async () => {
    if (cardid === "" ) {
      toast.error("เลขบัตรไม่ครบถ้วน\nกรุณาระบุก่อนค่ะ");
      return;
    }
    
    setstatus("0")
      const docdata = { IdentityID: cardid,Code : "2",BranchID : currentBranch._id};
      const { data: result } = await ConfirmData(docdata);
      if (result.status === "success") {
        toast.success("upload เสร็จเรียบร้อย");
        setstatus("1")
        setcardid("")
        
      }else{
        toast.error(result.message);
      }
   
  };
      const handleEndDate = (event)=>{
        setEndDate(event)
        setPageNumber(1)
        }
        const handleCancleSubmit = () => {
          setaskConfirm(false);
        };
        const observer = useRef();
        const scrollToTop = () => { 
            setPageNumber(1);
          }
  if (!ckPermit) return <></>;
return ( 
<>
<ConfirmSubmitface
            isOpen={askConfirm}
            list ={list}
            onConfirm={handleConfirmSubmit}
            onCancel={handleCancleSubmit}
            message={message}
            button1="OK"
          />
  <div className="row">
        <div className="col mb-1">
          <div className="card mb-1 text-dark p-0">
            <div className="card-body p-0">
              <div className="col-auto mb-1">
                <div className="container-fluid">
                  <div className="row justify-content-end">
                    <div className="col-auto me-auto">
                      
                      <h4>บริหารจัดการใบหน้า</h4>

                    </div>
                    </div>
                    <div className="row">
        <div className="col-auto">
              <div className="m-2">
               <i>
                  จากวันที่ 
                </i>
                <div
                  className="mt-2"
                  style={{ marginTop: 20, marginBottom: 20 }}
                >
                  <DatePicker
 className="datepicker-default form-control"
                    todayButton="Today"              
                    selected={startDate}
                    onChange={handleStartDate}
                   // showTimeSelect
                    // timeFormat="HH:mm"
                    // timeIntervals={60}
                    // timeCaption="time"
                    dateFormat="dd/MM/yyyy"
                  />
                </div>
              </div>
            </div>
            <div className="col-auto">
              <div className="m-2">
               <i>
                  ถึงวันที่ 
                </i>
                <div className="mt-2">
                  <DatePicker
 className="datepicker-default form-control"
                    todayButton="Today"
                   
                    selected={endDate}
                    onChange={handleEndDate}
                    //showTimeSelect
                    // timeFormat="HH:mm"
                    // timeIntervals={60}
                    // timeCaption="time"
                    dateFormat="dd/MM/yyyy"
                  />
                </div>
              </div>
            </div>
            <div className="container-fluid">
          <div className="row">
          <div className="col-auto mt-2">
           
           {/*<i>
          สถานะ 
           </i> */}
           <div className="mt-2 " style={{ marginTop: 20, marginBottom: 20 }}>
           
           <Headerproduct groupid={5} onChange={handleProductChange} />
           
         </div>
       </div>
       </div>        
        <div className="col-auto mt-2" >
        <p className="text-success">
        แสดงข้อมูล {facelist ? facelist.length : 0}  /  {total} รายการ
      </p>
      </div>
        </div>
          </div>
            </div>
              </div>
                </div>
                  </div>
                   </div>
                    </div>
  
          <ScrollToTop 
       onClick ={scrollToTop}
        />
          { reportId &&          
          <Renderface
        // reportcode ={reportId}
        // list = {reportlist}
        loading={loading}
        list={facelist}
        handleOnClick={handleonClick}
        error={error}
        //lastBookElementRef={lastBookElementRef}
          />} 
</>

     );
}
 
export default Manageface;